import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import App from './App';
import * as serviceWorker from './serviceWorker';

import configureStore from './modules/store';

const store = configureStore();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://aebcb425f70f4fa2b065c44930c79452@o435241.ingest.sentry.io/5393413',
  });
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
